import { ModalBody, ModalCloseButton, ModalContent, ModalRoot } from '@cian/ui-kit';
import { ArticleParagraph1 } from '@cian/ui-kit/typography';
import { IconActionClose16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import { getOfferTypeLabel } from '../../../../packages/Filters/shared/utils/offerType';
import { useDealType } from '../../../../packages/Filters/shared/utils/useDealType';
import { useFiltersContext } from '../../../../packages/Filters/shared/utils/useFiltersContext';
import { offerTypeFromJsonQuery } from '../../../../packages/JsonQuery';
import { ETestId } from '../../../common/constants';
import { Chip } from '../../components/RedesignedFilters';
import { useChip } from '../../hooks/useChip';
import { OfferTypeModalContainer } from '../OfferTypeModalContainer';

export const OfferTypeChipContainer = () => {
  const { jsonQuery } = useFiltersContext();
  const dealType = useDealType();
  const currentOfferType = offerTypeFromJsonQuery(jsonQuery);
  const { open, onChipClick, onCloseWithReset, onApplyClick } = useChip([]);
  const label = React.useMemo(() => getOfferTypeLabel(dealType, currentOfferType), [dealType, currentOfferType]);

  return (
    <ModalRoot open={open} onOpenChange={onCloseWithReset}>
      <Chip onClick={onChipClick} testId={ETestId.RedesignedFiltersOfferTypeChip}>
        <ArticleParagraph1>{label}</ArticleParagraph1>
      </Chip>
      <ModalContent>
        <ModalCloseButton title="Закрыть" size="XS" theme="fill_light" icon={<IconActionClose16 />} />
        <ModalBody>
          <OfferTypeModalContainer open={open} onClose={onCloseWithReset} onApplyClick={onApplyClick} />
        </ModalBody>
      </ModalContent>
    </ModalRoot>
  );
};
